module.exports = "<div>\r\n<div class=\"login-card\">\r\n\r\n</div>\r\n</div>"